import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Back from "../components/button/back";

const ListKegiatan = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/kegiatan`
      );
      setData(res.data);
    } catch (err) {
      console.error("Gagal mengambil data kegiatan", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getEmbedLink = (url) => {
    if (!url) return null;

    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const videoIdMatch = url.match(/(?:youtu\.be\/|v=)([^\s&]+)/);
      const videoId = videoIdMatch?.[1];
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }

    if (url.includes("drive.google.com")) {
      const fileIdMatch = url.match(/\/file\/d\/(.*?)\//);
      const fileId = fileIdMatch?.[1];
      return fileId
        ? `https://drive.google.com/file/d/${fileId}/preview`
        : null;
    }

    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
      {/* Back */}
      <div className="pt-5 pl-5">
        <Link to="/">
          <Back />
        </Link>
      </div>

      {/* Title */}
      <div className="font-bold text-center text-2xl sm:text-3xl py-5 text-gray-800 dark:text-white">
        Daftar Kegiatan
      </div>

      {/* Grid Kegiatan */}
      <div
        className="p-4 sm:p-6 grid gap-6
                      grid-cols-1
                      sm:grid-cols-2
                      md:grid-cols-3
                      lg:grid-cols-4"
      >
        {data.map((item) => {
          const hasMedia = item.media && item.media.length > 0;
          const firstMedia = hasMedia ? item.media[0] : null;
          const isImage = firstMedia?.mimetype?.startsWith("image");
          const isVideo = firstMedia?.mimetype?.startsWith("video");
          const embedLink = getEmbedLink(item.link);

          return (
            <div
              key={item._id}
              className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl overflow-hidden cursor-pointer
                         hover:scale-105 hover:shadow-2xl transition-transform duration-300"
              onClick={() => navigate(`/kegiatanall/${item._id}`)}
            >
              {/* Media */}
              <div className="relative w-full aspect-video bg-gray-200 dark:bg-gray-700 overflow-hidden">
                {isImage ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${firstMedia.filename}`}
                    alt={item.judul}
                    className="w-full h-full object-cover"
                  />
                ) : isVideo ? (
                  <video
                    src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${firstMedia.filename}`}
                    controls
                    className="w-full h-full object-cover bg-black"
                  />
                ) : embedLink ? (
                  <iframe
                    src={embedLink}
                    title="Video Link"
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <div className="flex items-center justify-center h-full text-gray-500 dark:text-gray-300 italic">
                    Tidak ada media
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2 line-clamp-2">
                  {item.judul}
                </h3>
                {item.link && !embedLink && (
                  <a
                    href={item.link}
                    className="text-blue-600 dark:text-blue-400 underline text-sm"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Lihat Link Video
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Back Button bawah */}
      <div className="pt-5 pb-5 pl-5">
        <Link to="/">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default ListKegiatan;
